export function console_log() {
  console.log("============");
  {
    console.log(...arguments);
  }
}
